/* ===========================================================
   PAGE SPEED COCONUT - OPTIMIZED JAVASCRIPT (FINAL CONSOLIDATION)
   =========================================================== */

// --- GLOBAL CAROUSEL MOVEMENT FUNCTIONS (Defined globally) ---
// These functions are called via inline onclick attributes
window.ytMove = function(dir) {
    const ytTrack = document.getElementById("ytTrack");
    if (!ytTrack) return;
    const slides = Array.from(ytTrack.querySelectorAll('.yt-slide'));

    function getVisibleYt() {
        return window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1;
    }

    let ytIndex = parseInt(ytTrack.dataset.ytIndex || 0);
    const perView = getVisibleYt();
    const maxIndex = slides.length - perView;
    
    ytIndex += dir;
    if (ytIndex < 0) ytIndex = 0;
    if (ytIndex > maxIndex) ytIndex = maxIndex;

    ytTrack.dataset.ytIndex = ytIndex; // Store new index

    const slideWidth = 100 / perView;
    const percent = ytIndex * slideWidth;
    ytTrack.style.transform = `translateX(-${percent}%)`;
    
    const ytDots = document.getElementById("ytDots");
    if (ytDots) {
        Array.from(ytDots.children).forEach((d, i) => d.classList.toggle("active", i === ytIndex));
    }
};

window.gpMove = function(d) {
    const gpTrack = document.querySelector(".gp-track");
    const gpDotsContainer = document.querySelector(".gp-dots");
    if (!gpTrack || !gpDotsContainer) return;
    
    const total = gpTrack.children.length;
    let gpIndex = parseInt(gpTrack.dataset.gpIndex || 0);

    gpIndex += d;
    if(gpIndex < 0) gpIndex = total - 1; 
    if(gpIndex >= total) gpIndex = 0;
    
    gpTrack.dataset.gpIndex = gpIndex; // Store new index

    gpTrack.style.transform = `translateX(-${gpIndex * 100}%)`;
    Array.from(gpDotsContainer.children).forEach((dot, i) => {
        dot.classList.toggle("active", i === gpIndex);
    });
};

// --- COUNTDOWN TIMER FUNCTION (Global, called on DOMContentLoaded) ---
function startHourlyCountdown() {
    const countdownElement = document.getElementById('countdown');
    if (!countdownElement) return;

    const offerDuration = 60 * 60 * 1000;
    let targetTime = localStorage.getItem('offerTargetTime');
    const now = new Date().getTime();

    if (targetTime) {
        targetTime = parseInt(targetTime);
        if (now > targetTime) {
            targetTime = now + offerDuration;
            localStorage.setItem('offerTargetTime', targetTime);
        }
    } else {
        targetTime = now + offerDuration;
        localStorage.setItem('offerTargetTime', targetTime);
    }

    function updateCountdown() {
        const currentTime = new Date().getTime();
        const distance = targetTime - currentTime;

        if (distance < 0) {
            clearInterval(timerInterval);
            countdownElement.innerHTML = "EXPIRED";
            localStorage.removeItem('offerTargetTime');
            return;
        }

        const totalSeconds = Math.floor(distance / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = Math.floor(totalSeconds % 60);
        
        const formattedTime = String(minutes) + ":" + String(seconds).padStart(2, '0');
        countdownElement.innerHTML = formattedTime;
    }

    updateCountdown();
    const timerInterval = setInterval(updateCountdown, 1000);
}


// --- MAIN DOM CONTENT LOAD (Wrapper for all logic) ---
document.addEventListener("DOMContentLoaded", function() {
    
    // Start the timer
    startHourlyCountdown();

    // 1. FAQ Accordion Logic
    document.querySelectorAll(".gp-faq-q").forEach(q => { 
        q.addEventListener("click", () => { 
            const isExpanded = q.classList.toggle("active");
            const answer = q.nextElementSibling;
            if (answer) {
                answer.classList.toggle("show");
                q.setAttribute('aria-expanded', isExpanded); // Accessibility
            }
        }); 
    });

    // 2. YouTube Placeholder Click-to-Load Logic
    const scrollEl = document.getElementById('ytScroll');
    if (scrollEl) {
        scrollEl.addEventListener('click', function (e) {
            const thumbBtn = e.target.closest('.yt-thumb'); 
            if (!thumbBtn) return;

            const card = thumbBtn.closest('.yt-card');
            const videoId = card?.dataset.videoId;
            if (!videoId) return;

            if (card.querySelector('iframe')) return; 

            const iframe = document.createElement('iframe');
            // FIX: Removed &mute=1 so audio plays immediately on user click.
            iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0'; 
            iframe.loading = 'lazy';
            iframe.title = 'Farmer Video Testimonial';
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframe.allowFullscreen = true;
            
            iframe.style.border = 'none';
            iframe.style.width = '100%';
            iframe.style.height = thumbBtn.offsetHeight + 'px';
            iframe.style.borderRadius = '14px';
            iframe.referrerPolicy = 'strict-origin-when-cross-origin';

            thumbBtn.replaceWith(iframe);
        });
    }


    // 3. Carousel/Scroller Initialization (Runs once after load)
    
    // YouTube Carousel Init
    const ytTrack = document.getElementById("ytTrack");
    const ytDots = document.getElementById("ytDots");
    if(ytTrack && ytDots) {
        const slides = Array.from(ytTrack.querySelectorAll('.yt-slide'));
        
        function getVisibleYt() {
            return window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1;
        }

        function updateYt() {
            const perView = getVisibleYt();
            const ytIndex = parseInt(ytTrack.dataset.ytIndex || 0);
            const slideWidth = 100 / perView;
            const percent = ytIndex * slideWidth;
            ytTrack.style.transform = `translateX(-${percent}%)`;
            Array.from(ytDots.children).forEach((d, i) => d.classList.toggle("active", i === ytIndex));
        }

        function createYtDots() {
            ytDots.innerHTML = "";
            const perView = getVisibleYt();
            const totalSteps = slides.length - perView + 1;
            
            for(let i=0; i < (totalSteps > 0 ? totalSteps : 1); i++) {
                const dot = document.createElement("div");
                dot.className = "yt-dot" + (i === 0 ? " active" : "");
                dot.onclick = () => { ytTrack.dataset.ytIndex = i; updateYt(); };
                ytDots.appendChild(dot);
            }
        }
        
        // Init logic
        createYtDots();
        updateYt();
        window.addEventListener("resize", () => { ytTrack.dataset.ytIndex = 0; createYtDots(); updateYt(); });
    }

    // Review Carousel Init
    const gpTrack = document.querySelector(".gp-track");
    const gpDotsContainer = document.querySelector(".gp-dots");
    if(gpTrack && gpDotsContainer) {
        const total = gpTrack.children.length;

        // Init Dots
        gpDotsContainer.innerHTML = "";
        for(let i=0; i<total; i++){
            const dot = document.createElement("div");
            dot.className = "gp-dot" + (i===0?" active":"");
            dot.onclick = () => { gpTrack.dataset.gpIndex = i; window.gpMove(0); }; // Use gpMove to update
            gpDotsContainer.appendChild(dot);
        }
        // Set initial state (assuming gpMove has been called once via onload/template)
        if (!gpTrack.dataset.gpIndex) gpTrack.dataset.gpIndex = 0;
    }
    
    // 4. IG Reels Scroller (Removed Intersection Observer conflict, relies on pure scroll)
    const igWrap = document.getElementById("gpIGReels");
    const igLeft = document.querySelector('.gp-arrow--left');
    const igRight = document.querySelector('.gp-arrow--right');
    if(igWrap && igLeft && igRight) {
      igLeft.onclick = () => igWrap.scrollBy({ left: -320, behavior: "smooth" });
      igRight.onclick = () => igWrap.scrollBy({ left: 320, behavior: "smooth" });
    }
});